import * as Sentry from "@sentry/react";

export function captureException(...args: Parameters<typeof Sentry.captureException>) {
  Sentry.captureException(...args);
}
